import {
    IonPage,
    IonButton,
    IonContent,
    useIonViewDidEnter,
    IonLoading,
} from '@ionic/react'
import React, { useState } from 'react'
import Header from '../../components/Header'
import WechatyMessage from '../../components/WechatyMessage'
import {
    MessageContent,
    MessageType,
    MessageItemType,
} from '../../components/WechatyMessage/interface'
import {
    createEmptyImageMessage,
    createEmptyTextMessage,
} from '../../components/WechatyMessage/componsents/tools'

import {
    addGroupWelcome,
    deleteGroupWelcome,
    getGroupWelcome,
} from '../../service/api/group'
import SelectMessage from '../SelectMessage'
import Upload from '../../components/Upload'
import Toast, { ToastProps } from '../../components/Toast'
import './index.css'

const GroupWelcome: React.FC<{}> = (props) => {
    const [msgList, setMsgList] = React.useState<MessageItemType[]>([])
    const [showLoading, setShowLoading] = React.useState(false)
    const uploadDiv = React.useRef<HTMLDivElement>(null)

    useIonViewDidEnter(() => {
        getGroupWelcome().then((res) => setMsgList(res.data))
    }, [])

    const handleAddImageMessage = (src: string, name: string) => {
        return setMsgList((list) => [...list, createEmptyImageMessage(src)])
    }

    const handleAddMessage = (m: MessageType) => {
        switch (m) {
            case MessageType.TEXT:
                return setMsgList((list) => [...list, createEmptyTextMessage()])
            case MessageType.IMAGE:
                // 关于图片类型的答案,应该选择了图片,就吊起上传框所以我们在这里
                return uploadDiv.current?.click()
            default:
                return null
        }
    }

    const handleChange = (value: MessageContent, index: number) => {
        setMsgList((list) => {
            const tmp = [...list]
            tmp[index] = { ...tmp[index], ...value }
            return tmp
        })
    }

    const handleDelete = (index: number) => {
        setMsgList((list) => {
            const tmp = [...list]
            tmp.splice(index, 1)
            return tmp
        })
        if (msgList[index].id) {
            deleteGroupWelcome([msgList[index].id as string])
        }
    }
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        position: 'top',
        color: 'success',
        duration: 1500,
    })
    const saveHandle = () => {
        const res = addGroupWelcome(msgList)
        res.then(
            () => {
                setToastToastOptions({
                    ...toastOptions,
                    isOpen: true,
                    message: '保存成功',
                })
            },
            () => {
                setToastToastOptions({
                    ...toastOptions,
                    isOpen: true,
                    color: 'error',
                    message: '保存失败',
                })
            }
        )
    }

    return (
        <IonPage>
            <IonContent className='baseContent'>
                <Header title='新人入群欢迎语' />
                <div className='groupWelcomeBox'>
                    <div className='groupWelcomeConfigBox'>
                        <div className='groupWelcomeTitle'>
                            <h1>新人入群欢迎语</h1>
                            <p>当有新人入群,机器人会发送欢迎语</p>
                        </div>
                        <div className='groupWelcomeIntroduce'>
                            <h6>欢迎语规则</h6>
                            <p>当有新的成员加入群聊,机器人会自动发送欢迎语</p>
                        </div>

                        <WechatyMessage
                            messageList={msgList}
                            onChnage={handleChange}
                            onDelete={handleDelete}
                        />

                        <SelectMessage
                            label='添加欢迎语'
                            onSelected={handleAddMessage}
                        />
                    </div>
                    <Upload
                        acceptType='image'
                        lt={20}
                        onResolve={handleAddImageMessage}
                        onStart={() => setShowLoading(true)}
                        onfinally={() => setShowLoading(false)}
                    >
                        <div ref={uploadDiv} />
                    </Upload>
                    <div className='groupWelcomeSubmitBtn'>
                        <IonButton expand='full' onClick={saveHandle}>
                            保存
                        </IonButton>
                    </div>

                    <IonLoading
                        isOpen={showLoading}
                        onDidDismiss={() => setShowLoading(false)}
                        message={'上传中,请等待'}
                    />
                    <Toast
                        {...toastOptions}
                        onClose={() => {
                            setToastToastOptions({
                                ...toastOptions,
                                isOpen: false,
                            })
                            // history.goBack()
                        }}
                    />
                </div>
            </IonContent>
        </IonPage>
    )
}

export default GroupWelcome
